var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivityService } from 'app/services/activity.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerService } from 'app/services/layer.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import WKT from 'ol/format/WKT';
var LineGeomEditWizardComponent = /** @class */ (function () {
    function LineGeomEditWizardComponent(toastr, activityService, appinfoService, attrIndexService, commonService, floatPopupService, gfoService, layerService, qcService, mainDataService, mapLayerService, mapService) {
        this.toastr = toastr;
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.floatPopupService = floatPopupService;
        this.gfoService = gfoService;
        this.layerService = layerService;
        this.qcService = qcService;
        this.mainDataService = mainDataService;
        this.mapLayerService = mapLayerService;
        this.mapService = mapService;
        this.steps = [
            {
                num: 1,
                label: 'Please select an edit option',
                prop: 'selectAction',
                isFirst: true,
            },
            {
                num: 2,
                label: '',
                prop: 'pickLine',
            }, {
                num: 3,
                label: 'Select a road centerline to be associated with',
                prop: null,
                isLast: true
            }
        ];
        this.actions = [{
                label: 'Modify',
                prop: 'edit'
            }, {
                label: 'Add',
                prop: 'add'
            }, {
                label: 'Delete',
                prop: 'delete'
            }];
        this.isNetworkTopoOn = true; // For network editing: keep topoMode or not
        this.selectedRoadsById = {};
    }
    LineGeomEditWizardComponent.prototype.close = function () {
        this.cancel();
    };
    LineGeomEditWizardComponent.prototype.cancel = function () {
        this.activityService.refreshData.next();
        this.removeAll();
        this.floatPopupService.closePopup(LineGeomEditWizardComponent);
    };
    LineGeomEditWizardComponent.prototype.addCards = function () {
        var _this = this;
        switch (this.currentAction) {
            case 'delete':
                Object.keys(this.selectedRoadsById).forEach(function (id) {
                    var attrs = _this.mainDataService.getDataAttrs(id);
                    if (!attrs) {
                        console.log('need debug: cannot find attrs.');
                        return;
                    }
                    _this.mainDataService.setDataAttrs(id, _this.attrIndexService.isDeletedKey, true);
                    _this.mainDataService.addRecToCard(id);
                });
                break;
            case 'edit':
            case 'add':
                var editHoldIds = this.activityService.editRecordHoldListBS.getValue().ids;
                var editedIds_1 = this.activityService.editRecordHoldListBS.getValue().ids;
                editHoldIds.forEach(function (recId) {
                    if (editedIds_1.indexOf(recId) === -1) {
                        editedIds_1.push(recId);
                    }
                });
                this.activityService.editRecordListBS.next({
                    ids: editedIds_1,
                    source: 'main'
                });
                break;
        }
        this.removeAll();
        this.activityService.changeTabSubject.next({
            tabKey: 'data'
        });
        this.floatPopupService.closePopup(LineGeomEditWizardComponent);
    };
    LineGeomEditWizardComponent.prototype.checkAddCardsDisabled = function (stepType) {
        if (stepType !== 'pickLine') {
            return true;
        }
        switch (this.currentAction) {
            case 'add':
            case 'edit':
                return !this.hasModifiedData;
            case 'delete':
                if (!Object.keys(this.selectedRoadsById).length) {
                    return true;
                }
                break;
        }
    };
    LineGeomEditWizardComponent.prototype.onSelectAction = function () {
        var step = this.steps.find(function (s) { return s.prop === 'pickLine'; });
        if (this.currentStep.num >= step.num) {
            // TODO: remove pick up, etc
        }
        this.changeCurrentStep(step);
    };
    LineGeomEditWizardComponent.prototype.toggleNetworkTopoMode = function () {
        // this.isNetworkTopoOn = !this.isNetworkTopoOn;
        this.activityService.networkTopoMode.next({
            isOn: this.isNetworkTopoOn
        });
    };
    LineGeomEditWizardComponent.prototype.removeAll = function () {
        this.stopPick();
        this.stopEdit();
        this.mapService.removeMapDblclickStop(this.map);
        if (this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
            this.map.removeLayer(this.mapLayerService.addressLineLayerName);
        }
        this.activityService.editRecordHoldListBS.next({
            ids: []
        });
    };
    LineGeomEditWizardComponent.prototype.stopPick = function () {
        this.mapService.endPickOnMap(this.map);
        this.mapService.removeMapDblclickStop(this.map);
    };
    LineGeomEditWizardComponent.prototype.startPickLinesDelete = function () {
        var _this = this;
        var layers = [this.mapLayerService.dataLayerName];
        this.mapService.startPickOnMap(this.map, layers, function (result) { return __awaiter(_this, void 0, void 0, function () {
            var line, lineLayer, featId, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        line = result.feat;
                        if (!line) return [3 /*break*/, 4];
                        lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
                        featId = line.getId();
                        info = this.selectedRoadsById[featId];
                        if (!info) return [3 /*break*/, 1];
                        delete this.selectedRoadsById[featId];
                        lineLayer.getSource().removeFeature(line);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.updateRoadsInfo([featId])];
                    case 2:
                        _a.sent();
                        info = this.selectedRoadsById[featId];
                        info.feat = line;
                        lineLayer.getSource().addFeature(line);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        this.toastr.info('Centerline not found.');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); }, null, this.attrIndexService.cursorArrow);
        this.mapService.addMapDblclickStop(this.map, function () {
            _this.mapService.endPickOnMap(_this.map);
        });
    };
    LineGeomEditWizardComponent.prototype.startEdit = function (id) {
        if (!this.mapService.mapEditing.getValue().isOn) {
            this.mapService.mapEditing.next({
                isOn: true,
                source: 'control',
                selectedId: id
            });
        }
    };
    LineGeomEditWizardComponent.prototype.stopEdit = function () {
        if (this.mapService.mapEditing.getValue().isOn) {
            this.mapService.mapEditing.next({
                isOn: false,
                source: 'control'
            });
        }
    };
    LineGeomEditWizardComponent.prototype.startAdd = function () {
        var _this = this;
        var dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
        this.mapService.addDrawInteraction(this.map, 'LineString', dataLayer);
        this.mapService.drawInteraction.on('drawend', function (e) {
            _this.mapService.removeDrawInteraction(_this.map);
            var feat = e.feature;
            var rec = _this.mainDataService.addNewCard(_this.attrIndexService.rcUuidCol, 'control', true);
            var recId = rec[_this.attrIndexService.rcUuidCol];
            // set geom
            var wktFormat = new WKT();
            var wktStr = wktFormat.writeGeometry(feat.getGeometry());
            _this.mainDataService.setDataAttrs(recId, _this.attrIndexService.geomColManual, wktStr);
            feat.setId(recId);
            if (_this.activityService.networkTopoMode.getValue().isOn) {
                _this.mapService.updateCenterlineTopo(feat, true);
            }
            // Wait till the feature is added to dataLayer before startEdit
            setTimeout(function () {
                _this.startEdit(recId);
            });
        });
        // this.mapService.addNewGeomSubject.next();
    };
    LineGeomEditWizardComponent.prototype.changeCurrentStep = function (step) {
        switch (step.prop) {
            case 'selectAction':
                break;
            case 'pickLine':
                if (this.currentAction === 'delete') {
                    step.label = 'Select centerlines on map to delete';
                    this.startPickLinesDelete();
                }
                else if (this.currentAction === 'edit') {
                    step.label = 'Edit a RCL, double click to end';
                    this.startEdit();
                }
                else if (this.currentAction === 'add') {
                    step.label = 'Single click to digitize RCL vertices, double click to end';
                    this.startAdd();
                }
        }
        this.currentStep = step;
    };
    LineGeomEditWizardComponent.prototype.updateRoadsInfo = function (featIds) {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, idsWithoutAttr, filter, gfo, rsp, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        idsWithoutAttr = featIds.filter(function (id) {
                            if (!_this.selectedRoadsById[id] || !_this.selectedRoadsById[id].attrs) {
                                var attrs = _this.mainDataService.getDataAttrs(id);
                                if (attrs) {
                                    if (!_this.selectedRoadsById[id]) {
                                        _this.selectedRoadsById[id] = {};
                                    }
                                    _this.selectedRoadsById[id].attrs = attrs;
                                    return false;
                                }
                                return true;
                            }
                        });
                        if (!idsWithoutAttr.length) return [3 /*break*/, 3];
                        filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.in.name, idsWithoutAttr);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                        return [4 /*yield*/, this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo, {
                                pageNumber: 0
                            })];
                    case 2:
                        rsp = _a.sent();
                        if (rsp.data) {
                            rsp.data.forEach(function (data) {
                                var featId = data[_this.attrIndexService.rcUuidCol];
                                _this.mainDataService.addDataToStoredRecords([data], _this.attrIndexService.rcUuidCol, 'replace');
                                if (!_this.selectedRoadsById[featId]) {
                                    _this.selectedRoadsById[featId] = {};
                                }
                                _this.selectedRoadsById[featId].attrs = data;
                            });
                        }
                        else {
                            this.toastr.warning('Can not find centerline attributes.');
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    LineGeomEditWizardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activityService.removeCurrentSelection();
        this.changeCurrentStep(this.steps[0]);
        // this.currentAction = this.actions[0].prop;
        // this.onSelectAction();
        this.centerlineLayerId = this.layerService.layerListBS.getValue().layers.find(function (l) { return l.category.code === _this.attrIndexService.cateCodeCenterline; }).id;
    };
    LineGeomEditWizardComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) {
            _this.map = data;
            if (!_this.map.addedLayers[_this.mapLayerService.addressLineLayerName]) {
                _this.mapLayerService.addAddressLineLayer(_this.map);
            }
        });
        this.networkTopoModeSub = this.activityService.networkTopoMode.subscribe(function (data) {
            _this.isNetworkTopoOn = data.isOn;
        });
        this.editListHoldSub = this.activityService.editRecordHoldListBS.subscribe(function (data) {
            if (data.ids && data.ids.length) {
                _this.hasModifiedData = true;
            }
            else {
                _this.hasModifiedData = false;
            }
        });
    };
    LineGeomEditWizardComponent.prototype.ngOnDestroy = function () {
        this.editListHoldSub.unsubscribe();
        this.mapSub.unsubscribe();
        this.networkTopoModeSub.unsubscribe();
    };
    return LineGeomEditWizardComponent;
}());
export { LineGeomEditWizardComponent };
